import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import _ from 'lodash';
import memo from '../memo';

const { TextArea } = Input;

interface JsonInputProps {
  value?: object | string;
  onChange?: (value: object) => void;
  [key: string]: any;
}

export function JsonTextarea({
  value,
  onChange,
  ...otherProps
}: JsonInputProps) {
  const [errorMessage, setErrorMessage] = useState('');
  const [_value, setValue] = useState('');
  const _onChange = (e: any) => {
    const v = e.target.value;
    let res;
    setErrorMessage('');
    setValue(v);
    if (v === '') {
      setErrorMessage('');
      onChange && onChange(v);
      return;
    }
    try {
      res = JSON.parse(v);
      setErrorMessage('');
      onChange && onChange(res);
    } catch (err: any) {
      setErrorMessage(err.message);
    }
  };

  useEffect(() => {
    if (_.isString(value)) {
      setValue(value);
    } else {
      setValue(JSON.stringify(value));
    }
  }, [value]);

  return (
    <span>
      <TextArea value={_value} onChange={_onChange} {...otherProps} />
      {errorMessage}
    </span>
  );
}
export const JsonTextareaMemo = memo(JsonTextarea);


export const JsonRender = ({
  value,
  rows,
}: {
  value: any;
  rows?: number;
}) => {
  const [viewAll, setViewAll] = useState(true);

  let str = value;
  if (_.isObject(value)) {
    try {
      str = JSON.stringify(value);
    } catch (e) {
      str = '';
    }
  }

  return (
    <div>
      <div
        style={{
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: viewAll ? undefined : rows,
          overflow: 'hidden',
        }}
      >
        {str}
      </div>
      {/* {str &&
        <div>
          {!viewAll && <a onClick={() => setViewAll(true)}>查看全部</a>}
          {viewAll && <a onClick={() => setViewAll(false)}>收起</a>}
        </div>
      } */}
    </div>
  );
};
